/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  PaymentCardsUserControllerDeleteMutationResponse,
  PaymentCardsUserControllerDeletePathParams,
  PaymentCardsUserControllerDelete400,
  PaymentCardsUserControllerDelete401,
  PaymentCardsUserControllerDelete404,
} from '../../types/PaymentCardsUserControllerDelete.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { paymentCardsUserDelete } from '../../methods/paymentCardsUserDelete.ts';
import { useMutation } from '@tanstack/react-query';

export const paymentCardsUserDeleteMutationKey = () => [{ url: '/api/user/payment-cards/:paymentSystem/:id' }] as const;

export type PaymentCardsUserDeleteMutationKey = ReturnType<typeof paymentCardsUserDeleteMutationKey>;

/**
 * @summary Unlink own saved card and disable auto renewal for its linked subscriptions
 * {@link /api/user/payment-cards/:paymentSystem/:id}
 */
export function usePaymentCardsUserDelete<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PaymentCardsUserControllerDeleteMutationResponse,
      ResponseErrorConfig<
        PaymentCardsUserControllerDelete400 | PaymentCardsUserControllerDelete401 | PaymentCardsUserControllerDelete404
      >,
      {
        paymentSystem: PaymentCardsUserControllerDeletePathParams['paymentSystem'];
        id: PaymentCardsUserControllerDeletePathParams['id'];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? paymentCardsUserDeleteMutationKey();

  return useMutation<
    PaymentCardsUserControllerDeleteMutationResponse,
    ResponseErrorConfig<
      PaymentCardsUserControllerDelete400 | PaymentCardsUserControllerDelete401 | PaymentCardsUserControllerDelete404
    >,
    {
      paymentSystem: PaymentCardsUserControllerDeletePathParams['paymentSystem'];
      id: PaymentCardsUserControllerDeletePathParams['id'];
    },
    TContext
  >(
    {
      mutationFn: async ({ paymentSystem, id }) => {
        return paymentCardsUserDelete(paymentSystem, id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
